import { getBuildConfigStr } from "./utils";

export const reCaptchaDefaults = {
  //sitekey: '6Les87YUAAAAAJ5opoyi8Z9yoeiSqgqZdQwdsAvS'
  //sitekey: '6LeFAt0UAAAAAAXLCCpchljIfS6D50Kad0kzRmov'
  sitekey: getBuildConfigStr('CAPTCHA')  
}
